<ht-modal [options]="modalOptions" (closeModalOutput)="onClose()" #modal>
  <div class="modal-content">
    <p
      >Access to Hubtype platform is for authorized Hubtype personnel only. Use
      of this application is restricted to legitimate business purposes and may
      be monitored to ensure compliance with company policies and data
      protection requirements.
    </p>

    <p> By continuing, you confirm that you: </p>

    <ul>
      <li>
        Understand and accept your responsibility to protect customer and
        company data
      </li>
      <li>
        Will use this system in accordance with Hubtype's security and
        confidentiality standards
      </li>
      <li>
        Acknowledge that unauthorized access or misuse may lead to disciplinary
        or legal action
      </li>
    </ul>
  </div>
</ht-modal>
